export default {
  titles: {
    default: 'Rappel de commande planifiée !',
    external_delivery: 'Livreur assigné !',
  },
  labels: {
    pickup: 'Retrait : {{time}}',
    serve: 'Service : {{time}}',
    preparation_time: 'Temps de préparation : {{time}} min',
  },
  buttons: {
    confirm: 'Commencer la préparation',
    print_and_confirm: 'Imprimer & commencer la préparation',
  },
  toasts: {
    something_went_wrong: "Une erreur s'est produite, veuillez réessayer",
  },
};
